import {createContext, useState, useContext, ReactNode, useEffect} from "react";

type AppContextType = {
  isLoggedIn: boolean;
  setIsLogin: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({children}: {children: ReactNode}) => {
  const [isLoggedIn, setIsLogin] = useState(() => {
    return localStorage.getItem("iris-portal-signed") === "true";
  });
  return (
    <AppContext.Provider value={{isLoggedIn, setIsLogin}}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context)
    throw new Error("useAppContext must be used within an AppProvider");
  return context;
};
